import { Routes } from '@angular/router';
import { ErrorPage } from './error.page';
import { NotFoundPage } from './not-found/not-found.page';

export const errorRoutes: Routes = [
	{
		path: '',
		loadComponent: () => Promise.resolve(ErrorPage)
	},
	{
		path: 'notfound',
		loadComponent: () => Promise.resolve(NotFoundPage)
	}
];
